import { useEffect, useState } from 'react';
import { getCheckout2026Value } from 'utils/ab-test/abTests';

type SkipChooseYourPlanGroup = ReturnType<typeof getCheckout2026Value>;

/** The group is only knowable in the browser, so it is read in an effect to keep server and client renders in sync.
 * Callers should wait for isLoaded before rendering anything that differs between groups. */
export const useSkipChooseYourPlan = () => {
  const [group, setGroup] = useState<SkipChooseYourPlanGroup | undefined>(
    undefined,
  );

  useEffect(() => {
    setGroup(getCheckout2026Value());
  }, []);

  return {
    group,
    isTestGroup: group === 'V1' || group === 'V2' || group === 'CONTROL_NP',
    isLoaded: group !== undefined,
  };
};
